

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M15.7996 7.81246C16.0896 7.49348 16.0616 7.00457 15.737 6.72073L8.58642 0.463913C8.26186 0.180081 7.7415 0.186026 7.42377 0.477317L0.248846 7.05432C-0.0688876 7.34561 -0.0844821 7.8339 0.214319 8.14448L0.394204 8.33183C0.69264 8.64242 1.17503 8.67945 1.47096 8.41429L2.00718 7.93409V14.9643C2.00718 15.3956 2.35667 15.7448 2.78769 15.7448H5.58449C6.01551 15.7448 6.365 15.3956 6.365 14.9643V10.046H9.93236V14.9643C9.92615 15.3953 10.2345 15.7445 10.6656 15.7445H13.6295C14.0605 15.7445 14.41 15.3953 14.41 14.964V8.03308C14.41 8.03308 14.5581 8.16284 14.7408 8.32343C14.9232 8.48371 15.3063 8.3552 15.5963 8.0359L15.7996 7.81246Z","fill":"#342245"}, []), "\n"]);
};

        